
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderBookGrid extends Serenity.EntityGrid<OrderBookRow, any> {
        protected getColumnsKey() { return OrderBookColumns.columnsKey; }
        protected getDialogType() { return OrderBookDialog; }
        protected getIdProperty() { return OrderBookRow.idProperty; }
        protected getInsertPermission() { return OrderBookRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderBookRow.localTextPrefix; }
        protected getService() { return OrderBookService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        }

        protected addButtonClick() {

            this.editItem({ OrderId: this.OrderId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {

            return this.OrderId != null;
        }


        private _OrderId: number;


        get OrderId() {
            return this._OrderId;
        }



        set OrderId(value: number) {
            if (this._OrderId != value) {
                this._OrderId = value;
                this.setEquality(OrderBookRow.Fields.OrderId, value);
                this.refresh();
            }
        }
    }
}